import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@mui/styles';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';

import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CachedIcon from '@mui/icons-material/Cached';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import PollIcon from '@mui/icons-material/Poll';

import PopupMenu from '../../../components/popupmenu';
import Tag from '../../../components/tags/tag';
import LabeledToolbar from '../../../components/styled/toolbar';

const MC2CHECK = process.env.BRICATA_APPLIANCE_TYPE === 'mc2';

const useStyles = makeStyles(theme => ({
    root: {
        padding: 10,
    },
    operator: {
        ...theme.typography.button,
        background: theme.palette.secondary.main,
        borderRadius: 5,
        display: 'inline',
        margin: 2,
        fontSize: 'small',
        padding: '3px 7px',
        width: 50
    },
    list: {
        display: 'flex',
        width: '100%',
        padding: 8,
        overflow: 'auto',
    },
    dropzone: {
        padding: 8,
        border: `1px dashed ${theme.palette.primary.main}`,
        width: '100%',
        minHeight: 32,

        '&.dragover': {
            border: `1px dashed ${theme.palette.secondary.main}`,
            cursor: 'copy',
        },

        '&.nodragover': {
            opacity: 0.5,
        },
    },
    toolbarContent: {
        padding: 8,
        verticalAlign: 'sub'
    },
    divider: {
        height: 40,
        marginTop: 10,
    },
}));

const GeomapToolbar = props => {
    const classes = useStyles();
    const theme = useTheme();

    const [tags, setTags] = useState([]);
    const [tagsOp, setTagsOp] = useState();
    const [pause, setPause] = useState(false);

    useEffect(() => {
        setTags(props.tagFilters || []);
        setTagsOp(props.tagsOp);
        setPause(props.pause);
    }, [props.tagFilters, props.tagsOp, props.pause]);

    return (
        <Grid container
            className={classes.root}
            spacing={1}
            direction="row"
            wrap='nowrap'
            justifyContent="space-between">
            <Grid item>
                {props.cmc &&
                    <span>CMC: <span
                        style={{
                            paddingRight: 10,
                            color: theme.palette.secondary.main
                        }}>{props.cmc.name}
                    </span> </span>
                }
                {MC2CHECK && !props.cmc &&
                    <span
                        style={{
                            paddingRight: 10,
                            color: theme.palette.secondary.main
                        }}>Please select CMC
                    </span>
                }
            </Grid>
            {/* <Grid item/> */}
            <Grid item style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                {tags.length > 0 &&
                        <PopupMenu
                            className={classes.root}
                            items={['Or', 'And', 'Not']}
                            onSelect={props.onTagsOpSelect}
                            icon={<div className={classes.operator}>{tagsOp}</div>}
                            size='small'
                            placement={'bottom-end'}/>
                }
                {tags.map((t, i) =>
                    <React.Fragment key={`${t}_${i}`} >
                        <Chip
                            size="small"
                            variant="outlined"
                            avatar={<Tag tag={t}/>}
                            label={t}
                            onDelete={() => props.onRemoveTag(t)}/>
                    </React.Fragment>
                )}
            </Grid>

            <Grid item>
                <LabeledToolbar>
                    {(!MC2CHECK || props.cmc) && <Button
                        size="small"
                        startIcon={<BookmarkIcon/>}
                        onClick={props.onTagAction} title="tag">
                        <p>Tag</p>
                    </Button>}
                    {(!MC2CHECK || props.cmc) && props.onFetch &&
                        <Divider orientation="vertical" className={classes.divider} flexItem />
                    }
                    {(!MC2CHECK || props.cmc) && props.onFetch && <Button
                        size="small"
                        startIcon={<CachedIcon/>}
                        onClick={props.onFetch} title="fetch latest" aria-label="fetch latest">
                        <p>Fetch</p>
                    </Button>}
                    {(!MC2CHECK || props.cmc) && props.onPause && !pause && <Button
                        size="small"
                        startIcon={<PauseIcon/>}
                        onClick={props.onPause} title="pause" aria-label="pause">
                        <p>Pause</p>
                    </Button>}
                    {(!MC2CHECK || props.cmc) && props.onPause && pause && <Button
                        size="small"
                        startIcon={<PlayArrowIcon/>}
                        onClick={props.onPause} title="resume" aria-label="resume">
                        <p>Resume</p>
                    </Button>}
                    {MC2CHECK && <PopupMenu
                        items={Object.entries(props.cmcs || {})
                            .map(([uuid, name]) => ({ uuid, name }))
                        }
                        itemkey="uuid"
                        itemTitle="name"
                        onSelect={props.onSetCmc}
                        tooltip="cmcs"
                        aria-label="cmcs"
                        disabled={(props.cmcs || []).length < 1}
                        button={<Button size="small" startIcon={<PollIcon/>}>
                            <p>CMC</p>
                        </Button>}
                        placement={'bottom-end'}/>}
                </LabeledToolbar>
            </Grid>
        </Grid>
    );
};

GeomapToolbar.propTypes = {
    tagFilters: PropTypes.array,
    tagsOp: PropTypes.string,
    pause: PropTypes.bool,
    onRemoveTag: PropTypes.func,
    onTagAction: PropTypes.func,
    onTagsOpSelect: PropTypes.func,
    onPause: PropTypes.func,
    onFetch: PropTypes.func,
    cmc: PropTypes.object,
    cmcs: PropTypes.object,
    onSetCmc: PropTypes.func,
};

export {
    GeomapToolbar as default,
};
